import React from 'react';
import styled, { css } from 'styled-components';
import { useFeatureFlag } from '@sparknz/feature-flags';
import { Link, LinkStyle, Text } from '@sparknz/spark-pattern-library';

import { TRADE_IN_PAGE } from 'shared/constants';
import { useProductDetails } from '../../../../provider';
import { ProductDetailsActionTypes } from '../../../../reducer/productDetails.reducer';
import { TradeInLayerStatus } from '../../../../typings';
import { FEATURES_ID, PLANS_ID, PRICING_ID } from '../../constants';

const QuickLinksContainer = styled.div`
  ${({ theme: { spacing, media } }) => css`
    margin-bottom: ${spacing.s5};
    text-align: center;

    ${media.up('slim')} {
      margin-bottom: 0;
      padding-top: ${spacing.s3};
    }
  `}
`;

const SpacedPipe = styled(Text)`
  ${({ theme: { spacing } }) => css`
    display: inline;
    padding: 0 ${spacing.s1_5};
  `}
`;

const StyledLink = styled.span`
  ${css`
    ${LinkStyle};
  `}
  cursor:pointer
`;

const QuickLinkDivider = () => {
  return <SpacedPipe variant="bodySMedium">|</SpacedPipe>;
};

const QuickLinks = () => {
  const { dispatch } = useProductDetails();
  const handleTradeInClick = () => {
    dispatch({
      type: ProductDetailsActionTypes.SetTradeInLayer,
      tradeInLayerStatus: TradeInLayerStatus.Open,
    });
  };
  const { value: shouldShowTradeInLayer } = useFeatureFlag(
    'release-pdp-trade-in-action-layer',
  );
  return (
    <QuickLinksContainer>
      <Link href={`#${PRICING_ID}`}>Pricing</Link>
      <QuickLinkDivider />
      <Link href={`#${PLANS_ID}`}>Plans</Link>
      <QuickLinkDivider />
      <Link href={`#${FEATURES_ID}`}>Features</Link>
      <QuickLinkDivider />
      {shouldShowTradeInLayer ? (
        <StyledLink onClick={handleTradeInClick}>Trade in</StyledLink>
      ) : (
        <Link href={TRADE_IN_PAGE}>Trade in</Link>
      )}
    </QuickLinksContainer>
  );
};

export default QuickLinks;
